module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-tabs', {
    attrs: {
      "md-fixed": ""
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "Register",
      "md-label": "Register",
      "md-active": _vm.isRegister
    }
  }, [_c('register', {
    on: {
      "login": _vm.onLogin
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "Setup",
      "md-label": "Setup",
      "md-active": _vm.isSetup
    }
  }, [_c('setup', {
    key: _vm.userId,
    attrs: {
      "userId": _vm.userId,
      "displayName": _vm.displayName
    }
  })], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "Activation",
      "md-label": "Activation",
      "md-active": _vm.isActivation
    }
  }, [_c('activation')], 1), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "Authentication",
      "md-label": "Authentication",
      "md-active": _vm.isAuthentication
    }
  }, [_c('authentication')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be3a9fe0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 104
// module chunks = 2